// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"2fbcc1db","977":"fbabd2a6"}[chunkId] + ".chunk.js";
};